/**
 * Typography tokens — Famílias de fontes centralizadas
 *
 * Evita que cada componente declare sua própria stack de fontes.
 * Importar daqui em vez de hardcodar fontFamily inline.
 */

export const fontFamilyMono = [
  '"JetBrains Mono"',
  '"Fira Code"',
  '"Roboto Mono"',
  '"SFMono-Regular"',
  'Consolas',
  '"Liberation Mono"',
  'Menlo',
  'monospace',
].join(', ');

export const fontFamilyDisplay = [
  '"Plus Jakarta Sans"',
  '"Segoe UI"',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(', ');

export const fontFamilyUI = [
  '"Inter"',
  '"Segoe UI"',
  '"Helvetica Neue"',
  'Helvetica',
  '"Lucida Grande"',
  'Arial',
  'Ubuntu',
  'Cantarell',
  '"Fira Sans"',
  'sans-serif',
].join(', ');
